import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoScreenComponent } from './video-screen/video-screen.component';
import { WinScreenComponent } from './win-screen/win-screen.component';
import { GameLevelComponent } from './game-level/game-level.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { FormsModule } from '@angular/forms';
import { CodeComponent } from './code/code.component';
import { LoadingComponent } from './loading/loading.component';

@NgModule({
    declarations: [
        VideoScreenComponent,
        WinScreenComponent,
        GameLevelComponent,
        HeaderComponent,
        CodeComponent,
        LoadingComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        TranslateModule
    ],
    exports: [
        VideoScreenComponent,
        WinScreenComponent,
        GameLevelComponent,
        HeaderComponent,
        CodeComponent,
        LoadingComponent
    ]
})
export class ComponentsModule {
}
